"use client";

import Link from "@/components/i18n/link";
import { ArrowLeft, Search } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useMessages } from "@/lib/i18n/client";
import messages from "./not-found.i18n";

// De cliente: not-found no recibe params, el idioma sale del contexto que
// arma app/[lang]/layout.tsx.
export default function NotFound() {
  const t = useMessages(messages);
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container-page flex min-h-[70vh] flex-col items-center justify-center py-24 text-center">
        <p className="text-7xl font-semibold text-primary">404</p>
        <h1 className="mt-4 text-2xl font-semibold tracking-tight md:text-3xl">{t.title}</h1>
        <p className="mt-3 max-w-md text-muted-foreground">{t.description}</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            href="/eventos"
            className="inline-flex h-11 items-center gap-2 rounded-full bg-primary px-6 text-sm font-semibold text-primary-foreground transition hover:bg-primary/90"
          >
            <Search className="h-4 w-4" />
            {t.explore}
          </Link>
          <Link
            href="/"
            className="inline-flex h-11 items-center gap-2 rounded-full border border-border bg-card px-6 text-sm font-medium transition hover:border-foreground/20"
          >
            <ArrowLeft className="h-4 w-4" />
            {t.home}
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
